export default [
  {
    name: 'APP_LOGOUT',
    callback: function () {
      this.$store.dispatch('auth/logout');
      this.$router.replace({ path: '/login' });
    },
  },
];
